import { RFXQuestion } from 'interfaces/RFXQuestionModel';

import {} from '../../interfaces/RFXBackendModel';
import { UIInput } from '../../types/uiTypes';
import { getRFXQuestionsForRequestQuery } from '../queries/getRFXQuestionsForRequestQuery';

export interface GetRFXQuestionsForRequestInput extends UIInput {
  rfxId: string;
  revision: number;
}

export async function getRFXQuestionsForRequest({
  apolloClient,
  rfxId,
  revision
}: GetRFXQuestionsForRequestInput): Promise<RFXQuestion[]> {
  const queryVariables = {
    rfxRequestRevisionedId: {
      id: {
        value: rfxId
      },
      revision: revision
    },
    maxResults: 100
  };

  const response = await apolloClient.query({
    query: getRFXQuestionsForRequestQuery,
    variables: queryVariables,
    fetchPolicy: 'network-only'
  });

  return response.data.getRFXQuestionsForRequest.rfxQuestions as RFXQuestion[];
}
